module.exports = __webpack_public_path__ + "static/media/Highland Ave San Carlos, CA3.71619102.jpg";